module.exports = __webpack_public_path__ + "img/zhu_yj_wanglianzhong.faa64aca.jpg";